export default __webpack_public_path__ + "media/images/ico-print-expertise-8d856211eb0742964b0d3ef220f34b3e.svg";